import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {CancelTripModalCategory} from './CancelTripModalCategory/CancelTripModalCategory';

export class CancelTripModalCategories extends Component {
    static propTypes = {
        cancellationReasonsByCategory: PropTypes.arrayOf(
            PropTypes.shape({
                category: PropTypes.string,
                descriptionText: PropTypes.string,
                text: PropTypes.string,
            })
        ),
        disclaimer: PropTypes.string,
        onSelectCategory: PropTypes.func,
    };

    static defaultProps = {
        disclaimer: '',
    };

    render() {
        const {cancellationReasonsByCategory, disclaimer} = this.props;
        let categories = [];

        if (cancellationReasonsByCategory) {
            cancellationReasonsByCategory.forEach((category, index) => {
                categories.push(
                    <CancelTripModalCategory
                        category={category}
                        key={index}
                        onClick={this.props.onSelectCategory}
                    />
                );
            });
        }

        return (
            <div className="CancelTrip__step">
                <div className="js-cancel-instructions">
                    <h3 className="js-cancel-category-text">
                        {this.props.title}
                    </h3>
                    <p>{disclaimer}</p>
                </div>
                {categories}
            </div>
        );
    }
}
